import { Component, OnInit } from '@angular/core';
import { CommonService } from '../_services';
import { Router } from '@angular/router';
import {ActivatedRoute} from '@angular/router';
import {environment} from '../../environments/environment';

@Component({
  selector: 'app-report-card-view',
  templateUrl: './report-card-view.component.html',
  styleUrls: ['./report-card-view.component.css']
})
export class ReportCardViewComponent implements OnInit {

  constructor(private activeroute: ActivatedRoute,private router: Router,
              private _service: CommonService) { }

  route:string;
  public state: string = environment.state;
  reportCardCount = [];
  regionList = [];
  districtList = [];
  countLoader = false;
  activeReport = 'closeReport';

  regionLoader = false;
  industryLoader = false;
  historyLoader = false;
  firstLevel:any = [];
  closeIndustryList = [];
  industryParameterList = [];
  closeIndustryHistory = [];
  selectedOfficerName = '';
  selectedRegionName = '';
  moreDetailDrilled = false;
  selectedIndustryName = '';
  selectedIndustryAddress = '';


  firstLevelExceedance:any = [];
  exceedanceIndustryList = [];
  industryParameterCount = [];
  exceedanceIndustryHistory = [];
  selectedOfficerNameExceedance = '';
  selectedRegionNameExceedance = '';
  moreDetailDrilledExceedance = false;
  selectedIndustryNameExceedance = '';
  selectedIndustryAddressExceedance = '';
  regionLoaderExceedance = false;
  industryLoaderExceedance = false;
  historyLoaderExceedance = false;

  regionFilter = '';
  districtFilter   = '';

  userData:any = [];

  userName;
  userLevel;
  searchField = {};

  ngOnInit() {

    this.userData = JSON.parse(localStorage.getItem('userData'));

    if(this.userData){
      this.userName = this.userData['user_profile_id'];
      this.userLevel = this.userData['access_level'];
    }

    if(this.userLevel == 'industry'){
      this.searchField['industryId'] = this.userName;
    }

    if(this.userLevel == 'vendor'){
      this.searchField['vendorId'] = this.userData['id']?this.userData['id']:'';
    }


    this.getReportCardCount();
    this.getRegionList();
    this.getDistrictList();
    this.getCloseIndustry();
  }

  getCloseIndustry(){

    this.regionLoader = true;
    this.route  = 'get-report-close_industry';
    const token = localStorage.getItem('userToken');

    let data = {'region':this.regionFilter,'district':this.districtFilter};

    this._service.postRequestCreator(data, this.route, token).subscribe((response: any) => {

      if(response.status == 204) {
        localStorage.removeItem('userToken');
        localStorage.removeItem('userData');
        this.router.navigate(['login']);
        // location.reload();
      }
      if(response.status == 200){


        if(response.result.length != 0){
          this.firstLevel = response.result;
        }else{
          this.firstLevel = false;
        }

      }
      this.regionLoader = false;
    });
  }

  getCloseIndustryList(regionName,officerName){

    this.industryLoader = true;
    this.moreDetailDrilled = false;
    this.selectedRegionName = regionName;
    this.selectedOfficerName = officerName;

    this.route  = 'get-close_industry-list';
    const token = localStorage.getItem('userToken');

    let data = {'region_name':regionName};

    this._service.postRequestCreator(data, this.route, token).subscribe((response: any) => {

      if(response.status == 204) {
        localStorage.removeItem('userToken');
        localStorage.removeItem('userData');
        this.router.navigate(['login']);
        // location.reload();
      }
      if(response.status == 200){
        this.closeIndustryList = response.data;
        this.industryParameterList = response.parameter;
      }
      this.industryLoader = false;
    });
  }

  getIndustryCloseTimeWise(industryName,industryAddress,industryId){

    this.historyLoader = true;
    this.moreDetailDrilled = true;
    this.selectedIndustryName = industryName;
    this.selectedIndustryAddress = industryAddress;

    this.route  = 'get-close-industry-history';
    const token = localStorage.getItem('userToken');

    let data = {'industry_id':industryId};

    this._service.postRequestCreator(data, this.route, token).subscribe((response: any) => {

      if(response.status == 204) {
        localStorage.removeItem('userToken');
        localStorage.removeItem('userData');
        this.router.navigate(['login']);
        // location.reload();
      }
      if(response.status == 200){
        this.closeIndustryHistory = response.data;
      }
      this.historyLoader = false;
    });

  }

  backToPreviousLevel(){
    this.moreDetailDrilled = false;
  }

  getRegionList(){
    this.countLoader = true;
    this.route  = 'get-region-list';
    const token = localStorage.getItem('userToken');

    let data = [];

    this._service.postRequestCreator(data, this.route, token).subscribe((response: any) => {

      if(response.status == 204) {
        localStorage.removeItem('userToken');
        localStorage.removeItem('userData');
        this.router.navigate(['login']);
      }
      if(response.status == 200){
        this.regionList = response.data;
      }
    });
  }

  getDistrictList(){
    this.countLoader = true;
    this.route  = 'get-all-city-list';
    const token = localStorage.getItem('userToken');

    let data = [];

    this._service.postRequestCreator(data, this.route, token).subscribe((response: any) => {

      if(response.status == 204) {
        localStorage.removeItem('userToken');
        localStorage.removeItem('userData');
        this.router.navigate(['login']);
      }
      if(response.status == 200){
        this.districtList = response.data;
      }
    });
  }



  getReportCardCount(){
    this.countLoader = true;
    this.route  = 'get-report-card-counts';
    const token    = localStorage.getItem('userToken');
    this.reportCardCount = [];

    let data = {'region':this.regionFilter,'district':this.districtFilter};
    // let data = [];

    this._service.postRequestCreator(data, this.route, token).subscribe((response: any) => {

      if(response.status == 204) {
        localStorage.removeItem('userToken');
        localStorage.removeItem('userData');
        this.router.navigate(['login']);
        // location.reload();
      }
      if(response.status == 200){
        this.reportCardCount = response.data;
      }
      this.countLoader = false;
      // this.industryListLoader = false;
    });
  }

  applyFilter(){

    this.getReportCardCount();

    if(this.activeReport == 'closeReport'){
      this.getCloseIndustry();
    }
    if(this.activeReport == 'exceedanceReport'){
      this.getExceededIndustry();
    }
  }

  switchReportList(type){
    this.activeReport = type;

    if(type == 'closeReport'){
      this.getCloseIndustry();
    }

    if(type == 'exceedanceReport'){
      this.getExceededIndustry();
    }

  }


  getExceededIndustry(){
    this.regionLoaderExceedance = true;
    this.route  = 'get-exceeded-industry-region-wise';
    const token = localStorage.getItem('userToken');
    let data = {'region':this.regionFilter,'district':this.districtFilter};

    this._service.postRequestCreator(data, this.route, token).subscribe((response: any) => {

      if(response.status == 204) {
        localStorage.removeItem('userToken');
        localStorage.removeItem('userData');
        this.router.navigate(['login']);
        // location.reload();
      }
      if(response.status == 200){

        if(response.result.length != 0){
          this.firstLevelExceedance = response.result;
        }else{
          this.firstLevelExceedance = false;
        }
      }
      this.regionLoaderExceedance = false;
    });
  }

  getExceedanceIndustryList(regionName,officerName){

    this.industryLoaderExceedance = true;
    this.moreDetailDrilledExceedance = false;
    this.selectedRegionNameExceedance = regionName;
    this.selectedOfficerNameExceedance = officerName;

    this.route  = 'get-exceedance-industry-list';
    const token = localStorage.getItem('userToken');
    let data = {'region_name':regionName};
    this._service.postRequestCreator(data, this.route, token).subscribe((response: any) => {

      if(response.status == 204) {
        localStorage.removeItem('userToken');
        localStorage.removeItem('userData');
        this.router.navigate(['login']);
        // location.reload();
      }
      if(response.status == 200){
        this.exceedanceIndustryList = response.data;
        this.industryParameterCount = response.total_parameter_ind_count;
      }
      this.industryLoaderExceedance = false;
    });
  }

  getIndustryExceedanceHistory(industryName,industryAddress,industryId){

    this.historyLoaderExceedance = true;
    this.moreDetailDrilledExceedance = true;
    this.selectedIndustryNameExceedance = industryName;
    this.selectedIndustryAddressExceedance = industryAddress;

    this.route  = 'get-industry-exceedance-history';
    const token = localStorage.getItem('userToken');

    let data = {'industry_id':industryId};

    this._service.postRequestCreator(data, this.route, token).subscribe((response: any) => {

      if(response.status == 204) {
        localStorage.removeItem('userToken');
        localStorage.removeItem('userData');
        this.router.navigate(['login']);
        // location.reload();
      }
      if(response.status == 200){
        this.exceedanceIndustryHistory = response.data;
      }
      this.historyLoaderExceedance = false;
    });
  }

  backToPreviousLevelExceedance(){
    this.moreDetailDrilledExceedance = false;
  }


}
